<div *ngIf="internalCalculation"
  class="offline-badge"
  (mouseenter)="offlineMessage=tooltipMessage"
  (mouseleave)="offlineMessage=''">
  <span class="offline"> Offline </span>
  <cx-icon class="regular-icon active" [type]="icon"></cx-icon>
  <gen-info-message [icon]="null" [message]="offlineMessage" [position]="'position-right'"></gen-info-message>
</div>